<template>
  <qx-card-form title="收款信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="receiver" slot-scope="prop">
        <ChooseReceiver
          :isRadio="true"
          v-model="prop.form.receiver"
          @change="handleReceiverChange"
        />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import ChooseReceiver from 'components/choose/receiver';
export default {
  components: {
    ChooseReceiver,
  },
  data () {
    return {
      acUserId: '',
      baseForm: {
        orgIdOptions: [],
        form: [
          {
            label: '收款人',
            value: 'receiver',
            default: {},
            slot: true,
          },
          {
            label: '收款账户名',
            value: 'receUserName',
            type: 'input',
            disabled: true,
          },
          {
            label: '收款银行',
            value: 'receBankName',
            type: 'input',
            disabled: true,
          },
          {
            label: '收款账号',
            value: 'receBankNo',
            type: 'input',
            disabled: true,
          },
        ],
        rules: {
          receiver: [ // 收款人
            { required: true, message: '请选择收款人', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    handleReceiverChange (receiver) { // 收款人变化
      this.acUserId = String(receiver.userId);
      this.$refs.baseForm.setVal('receUserName', receiver.receiverName);
      this.$refs.baseForm.setVal('receBankName', receiver.bankName);
      this.$refs.baseForm.setVal('receBankNo', receiver.acctNo);
      this.$refs.baseForm.setVal('selectedLIds', []);
    },

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (formData.receiver) {
          formData.receName = formData.receiver.receiverName; // 收款方名称
          formData.receUserName = formData.receiver.acctName; // 收款账户名
          formData.receBankName = formData.receiver.bankName; // 收款方银行
          formData.receBankNo = formData.receiver.acctNo; // 收款方银行卡号
          formData.receAccNo = formData.receiver.pinganCollectAcctId; // 收款方账户
          formData.receUserType = formData.receiver.userType; // 收款方类型
          formData.receUserId = formData.receiver.userId; // 收款方ID
          formData.balanceType = formData.receiver.balanceType; // 结算方式
          formData.expireDate = this.formatDate(formData.receiver.expireDate || new Date()); // 到期时间
          delete formData.receiver;
        }
        formData.userType = formData.receUserType;
      }
      return formData;
    },

    async sub () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData();
      return res;
    },
    async init (data = {}) {
      if (data.receName) {
        data.receiver = {
          receiverName: data.receName, // 收款方名称
          acctName: data.receUserName, // 收款账户名
          bankName: data.receBankName, // 收款方银行
          acctNo: data.receBankNo, // 收款方银行卡号
          pinganCollectAcctId: data.receAccNo, // 收款方账户
          userType: data.receUserType, // 收款方类型
          userId: String(data.receUserId), // 收款方ID
          balanceType: data.balanceType, // 结算方式
        };
      } else {
        data.receiver = {};
      }
      this.acUserId = data.receUserId ? String(data.receUserId) : null; // 收款人id
      this.$refs.baseForm.setVal('form', data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
